import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { isFedRamp } from '@atlassian/atl-context';

/**
 * Same behaviour as `@confluence/content-types-utils/entry-points/isContentTypeEnabledInCurrentEnv`
 * for platform consumers (no Confluence package dependency).
 */
export const isContentTypeEnabledInCurrentEnv = (
	contentType: 'whiteboard' | 'database' | 'slide' | null | undefined,
): boolean => {
	if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
		if (fg('use_frontend_feature_encoding_sdk')) {
			const featureKeyMap: Record<string, string> = {
				database: 'confluence-databases',
				slide: 'confluence-slides',
				whiteboard: 'confluence-whiteboards',
			};
			return isFeatureEnabled('confluence', featureKeyMap[contentType]);
		}
		return !isFedRamp();
	}

	return true;
};
